/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABwklEQVR4nOVUyypFYRTeRkpJuWSAsRGlPICJnNjrcga/tQ55AyZSKCMjnsArIGWqiDh5BW9ABu4nlITWv7fDOexzaR8jq1bt9l77+9b/re9fQfAvgkj6kGUHWB8skWUX0fU3DBxIr5H1vTTlxr6lJkCWnZ/gcZJupyYAL0kCAcv9nxIA6V1qArSBJkokW+kJ0PXbQH92L1fZ7HRv0DCbkm6b5j5JthoG/qdhXQLJIrAeA8s5kL5GKRfAeoIsS8659rqBM5lMM7KsI8lzskW9TS+JpgbqA3euC1hPKwOrd5Bzrq3uzmsBB9bNIAia7B/IagZY9sxpQFpA1gOiyTGPQ5IvIfCyVOuc5RIRW6N6Xa1WXzLQ6pqr5YrVE+XG4/vwgizzYZjrnJhwPcC6HL0rIzC31AD+DqCDvp51Pz7RfBHjF3m/CLztijvmLIkgDMOWqKFohVvnRYlJ8mWzOvl+gosYvEAkI9UIMF4fzDMdNTkISJ9iTTcqESDqUHzio3KJKgayriHrI6IOQ1ZHkfXtF4I3G66vR8XPIYckCwDabXfIP7PcAstsTcSVm0q2NZDOpSawABYC1kNvTZJnc5ddvs+CD+cAvZw8/NEKAAAAAElFTkSuQmCC)
 */
export const UserRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h1.24A3 3 0 0 0 19 16Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M16.08 11.7c.41.18.36.77-.05.96a7 7 0 0 0-3.65 8.6c.11.36-.13.74-.5.74H6.15a.5.5 0 0 1-.5-.55l.27-2.6c.02-.26-.27-.37-.41-.16-.48.74-1.03 1.8-1.32 2.9a.53.53 0 0 1-.5.41h-.22C2.66 22 2 21.34 2 20.53A9.53 9.53 0 0 1 11.53 11h.94c1.28 0 2.5.25 3.61.7ZM16 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
